import View, { ViewOpts } from '@play-co/timestep-core/lib/ui/View';
import {
  ImageCoverView,
  ImageCoverViewOpts,
  ImageScaleView,
  ImageScaleViewOpts,
  ImageView,
} from '@play-co/timestep-core/ui';
import { ImageViewOpts } from '@play-co/timestep-core/lib/ui/ImageView';
import MaskedView from '../../lib/ui/components/MaskedView';
import LangBitmapFontTextView, {
  LangBitmapOpts,
} from '../../lib/ui/components/LangBitmapFontTextView';
import { clamp } from 'src/replicant/utils';

export type HudMeterOpts = {
  view: ViewOpts;
  image: ImageCoverViewOpts;
  fill: ImageViewOpts;
  mask: Omit<
    ConstructorParameters<typeof MaskedView>[0],
    'sourceView' | 'superview'
  >;
  highlight: ImageCoverViewOpts;
  label: ImageScaleViewOpts;
  text: LangBitmapOpts;
  labelSufix?: string;
};

export class HudMeter extends View {
  private meter: MaskedView;
  private label: LangBitmapFontTextView;
  private labelSufix: string;

  constructor({
    view,
    image,
    fill,
    mask,
    highlight,
    label,
    text,
    labelSufix,
  }: HudMeterOpts) {
    super(view);
    const { width } = view;

    this.labelSufix = labelSufix ?? ' %';

    const meterBackground = this.addSubview(new ImageCoverView(image));
    const sourceView = new ImageView(fill);
    this.meter = new MaskedView({
      ...mask,
      superview: meterBackground,
      sourceView,
    });

    this.addSubview(new ImageCoverView(highlight));

    const labelWidth = width! - 12;
    const labelBackground = this.addSubview(
      new ImageScaleView({
        ...label,
        x: 3,
        width: labelWidth,
      }),
    );

    this.label = new LangBitmapFontTextView({
      ...text,
      superview: labelBackground,
      y: -1,
      width: labelWidth - 2 * text.x!,
    });
  }

  public setMeterValue(value: number) {
    this.label.localeText = () => `${Math.ceil(value * 100)}${this.labelSufix}`;
    const { height } = this.meter.style;
    this.meter.updateSourceOpts({
      offsetY: clamp((1 - value) * height, 0, height),
    });
  }

  public updateLabelOpts(opts: Partial<LangBitmapOpts>) {
    this.label.updateOpts(opts);
  }
}
